// extracted by mini-css-extract-plugin
export default {"tagDelete":"SearchUtm_tagDelete__aVa9w","tagDeleteIco":"SearchUtm_tagDeleteIco__-J-nx"};